/*
 * Per-variant image filter.
 * Shopify links only ONE image per variant natively, so the PIM stamps every
 * image's alt text with its owning variant SKU ([sku:KN-66736]); the theme
 * (snippets/product.liquid) turns that into a data-owner-sku on each gallery
 * tile. This script shows only the selected colour's tiles and hides the rest.
 *
 * Safe default: a tile with an EMPTY data-owner-sku (shared image, or a product
 * not yet backfilled) is never hidden — so un-stamped products behave exactly
 * as before.  See VARIANT-IMAGE-FILTER.md.
 */
(function () {
  'use strict';

  // Hide every tile in `scope` whose owner SKU is set AND not the selected one.
  function applyFilter(scope, sku) {
    if (!scope || !sku) return;
    var tiles = scope.querySelectorAll('[data-owner-sku]');
    for (var i = 0; i < tiles.length; i++) {
      var owner = tiles[i].getAttribute('data-owner-sku');
      var hide = owner !== '' && owner !== sku;
      tiles[i].classList.toggle('variant-hidden', hide);
    }
    refilterZoom(scope);
  }

  // Rebuild the MagnificPopup zoom gallery so its prev/next only cycles the
  // currently-visible (selected variant) images. MagnificPopup captures its
  // item list when california.js binds it at page load, so hiding tiles via CSS
  // alone is not enough — we re-bind to the visible set on every variant change.
  function refilterZoom(scope) {
    var jq = window.jQuery;
    if (!jq || !jq.fn || !jq.fn.magnificPopup) return;
    var $links = jq(scope).find('[data-mfp-src]');
    if (!$links.length) return;
    var src = $links.first().data('magnificPopup');
    if (!src) return; // california hasn't bound mfp yet — retried on load + next change
    var cfg = {};
    for (var k in src) {
      if (k !== 'items' && k !== 'isObj') cfg[k] = src[k];
    }
    $links.off('click.magnificPopup');
    var $vis = $links.filter(function () {
      return jq(this).closest('.variant-hidden').length === 0;
    });
    if ($vis.length) $vis.magnificPopup(cfg);
  }

  // The product gallery container that holds a given tile.
  function scopeForSku(sku) {
    var esc = window.CSS && CSS.escape ? CSS.escape(sku) : sku.replace(/"/g, '\\"');
    var tile = document.querySelector('[data-owner-sku="' + esc + '"]');
    return tile
      ? tile.closest('[data-section-type="product"], .custom-pdp') || document
      : document;
  }

  // Theme dispatches this on every colour/option change (california.js:1698).
  document.addEventListener('variant:change', function (e) {
    var v = e && e.detail && e.detail.variant;
    if (!v || !v.sku) return;
    applyFilter(scopeForSku(v.sku), v.sku);
  });

  // Initial state: filter each product block by its current variant.
  function initialFilter() {
    var blocks = document.querySelectorAll('[data-section-type="product"][data-section-id]');
    for (var i = 0; i < blocks.length; i++) {
      var sid = blocks[i].getAttribute('data-section-id');
      var jsonEl = document.getElementById('ProductCurrentVariantJson-' + sid);
      if (!jsonEl) continue;
      try {
        var v = JSON.parse(jsonEl.textContent);
        if (v && v.sku) applyFilter(blocks[i], v.sku);
      } catch (err) {
        /* leave gallery untouched on parse failure */
      }
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initialFilter);
  } else {
    initialFilter();
  }
  // Re-run once MagnificPopup is definitely bound (california.js init on load),
  // so the initial variant's zoom gallery is also limited to its own images.
  window.addEventListener('load', initialFilter);
})();
